<script>
    export default {
        mixins: [],
        data(){
            return Object.assign({
                name: this.init_name,
                url: '/user-preference/shortcut/quick-add',
            }, {locale: window.locale,}, __FORM__);
        },
        props: {
            init_name: {
                type : String,
                required : true,
            },
            path: {
                type : String,
                required : true,
            },
            sub_system: {
                type : String,
                required : true,
            },
            __c_module: {
                type : String,
                required : true,
            },
        },
        methods: {
            submit(){
                let formData = this.getFormData();
                let ajaxSuccessCallback = (response) => {
                    this.$nextTick(() =>  {
                        window.location.href = this.path;
                        this.$store.commit('setRedirectNotification', response.data.msg);
                        this.$store.commit('setNotificationType', 'success');
                    });
                };
                let ajaxFailCallback = (error) => {
                    if (error.response.status == '422') {
                        this.$store.commit('setValidationError', error.response.data.errors)
                    } else {
                        this.$store.commit('setError', error.response.data.msg)
                    }
                };
                this.$root.ajax_call(this.url, 'post', formData, ajaxSuccessCallback, ajaxFailCallback, true);
            },
            getFormData() {
                let formData = {};
                formData = {
                    path: this.path,
                    name: this.name,
                    sub_system: this.sub_system,
                    __c_module: this.__c_module,
                };

                return formData;
            },
        },
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/Modules/user-preference/ShortcutQuickAdd.vue